import React, { useContext } from 'react';
import { InputField, SelectField } from '@trp-beacon-ui-kit/react-controls';
import { FlowContext } from '../../core/flow-engine';
import SubHeading from '../Typography/SubHeading/SubHeading';
import {
  addressLine2Validation,
  addressLine1Validation,
  zipCodeValidation
} from '../../flows/shared/validations';
import { states } from '../../screens/ContactInformationScreen/utils';
import styles from './FONASUCustodianBranchAddressInfo.css';
import { BranchAddressTitleWithTooltip } from '../../screens/CustodianAddressDetailsScreen/CustodianAddressDetailsScreen';

export const FONASUCustodianBranchAddressInfo = () => {
  const {
    formProps,
    appState: {
      store: {
        app: { custodian }
      }
    }
  } = useContext(FlowContext);

  return (
    <>
      <div className="section-header">
        <SubHeading text="Custodian Branch Information" />
      </div>
      <div className="address-wrapper">
        <div className="qv-row">
          <div className="qv-col">
            <InputField
              title={<BranchAddressTitleWithTooltip />}
              {...formProps.custodianBranchAddressStreet1}
              defaultValue={custodian?.custodianAddress?.street1}
              validation={addressLine1Validation}
              maxLength="35"
            />
          </div>
          <div className="qv-col">
            <InputField
              title="Address Line2 (optional)"
              {...formProps.custodianBranchAddressStreet2}
              defaultValue={custodian?.custodianAddress?.street2}
              validation={addressLine2Validation}
              maxLength="35"
            />
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <InputField
              type="text"
              title="City"
              {...formProps.custodianBranchCity}
              defaultValue={custodian?.custodianAddress?.city}
            />
          </div>
          <div className="qv-col">
            <InputField
              type="text"
              title="Zip Code"
              {...formProps.custodianBranchZip}
              defaultValue={custodian?.custodianAddress?.zip}
              validation={zipCodeValidation}
            />
          </div>
          <div className="qv-col">
            <SelectField
              title="State"
              {...formProps.custodianBranchState}
              defaultValue={custodian?.custodianAddress?.state}>
              <option hidden value="">
                State
              </option>
              {states.map(item => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </SelectField>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export const FONASUCustodianSpecialAddressReview = () => {
  const {
    appState: {
      store: {
        app: {
          custodian: { custodianAddress }
        }
      }
    }
  } = useContext(FlowContext);

  const { street1, street2, city, zip, state } = custodianAddress;

  return (
    <div className="review-section">
      <div className="address-review-wrapper">
        <div className="section-header">
          <SubHeading text="Custodian Branch Information" />
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">Address Line 1</div>
            <div className="field-value">{street1}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Address Line 2</div>
            <div className="field-value">{street2}</div>
          </div>
        </div>
        <div className="qv-row">
          <div className="qv-col">
            <div className="field-label">City</div>
            <div className="field-value">{city}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">Zip Code</div>
            <div className="field-value">{zip}</div>
          </div>
          <div className="qv-col">
            <div className="field-label">State</div>
            <div className="field-value">{state}</div>
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
};

export default FONASUCustodianBranchAddressInfo;
